import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  Select,
  Steps,
  Collapse,
} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ViewFormComponent from "../../components/ViewFormComponent";
import ListFormComponent from "../../components/ListFormComponent";
import EditFormComponent from "../../components/EditFormComponent";
import InputTableComponent from "../components/InputTableComponent";
import DependenciesComponent from "../../components/DependenciesComponent";
import ReportEditorPage from "./ReportEditorPage";
import CocPage from "./CocPage.js";
import {useAxios} from "../../hooks/hooks";
import {Link} from "react-router-dom";

const { Step } = Steps;
const { Option } = Select;
const { Panel } = Collapse;
// const GOOGLE_MAPS_API_KEY = config.googlemaps_api_key;

function ProjectPage(props) {
  const axios = useAxios();
  const [currentStep, setCurrentStep] = useState(0);
  // const [staticMapURL, setStaticMapURL] = useState(null);
  const [cocs, setCocs] = useState([]);
  const [coc, setCoc] = useState(null);
  const [currentCOC, setCurrentCOC] = useState(null);
  const [project, setProject] = useState(null);
  const [nonce, setNonce] = useState(0);
  const [steps, setSteps] = useState([
    {
      status: "finish",
      title: "Request",
    },
    {
      status: "wait",
      title: "Inspection",
    },
    {
      status: "wait",
      title: "Laboratory",
    },
    {
      status: "wait",
      title: "Report",
    },
  ]);

  const ProjectWarnings = () => {
    return (
      <>
        {project !== null && !project.id_author && (
          <Alert
            message="Please, assign a Project Manager."
            type="info"
            showIcon
          />
        )}
        {project !== null && !project.id_inspector && (
          <Alert
            message="Please, assign a Project Consultant."
            type="info"
            showIcon
          />
        )}
        {project !== null && !project.id_reviewer && (
          <Alert
            message="Please, assign a Project Reviewer."
            type="info"
            showIcon
          />
        )}
        {project !== null && !project.inspection_date_project && (
          <Alert
            message="Please, set the Project Inspection Date."
            type="info"
            showIcon
          />
        )}
        {project !== null && !project.report_date_project && (
          <Alert
            message="Please, set the Project Report Date."
            type="info"
            showIcon
          />
        )}
        {project !== null && project.polygon_project === "[]" && (
          <Alert
            message="Please, draw a Project Polygon."
            type="warning"
            showIcon
          />
        )}
        {project !== null && !project.inspection_date_project && (
          <Alert
            message="Please, set the Project inspection date."
            type="info"
            showIcon
          />
        )}
        {currentCOC !== null && currentCOC.results_date_coc === null && (
          <Alert
            message="Please, set the COC results date."
            type="info"
            showIcon
          />
        )}
      </>
    );
  };
  const StepsHeader = (propz) => {
    return (
      <DependenciesComponent
        mode="block"
        dependencies={["coc", "projects"]}
        {...props}
      >
        <PageHeader
          title="Project Mode Panel"
          style={{ padding: "0px 0px 16px 0px" }}
          extra={[
            <Select
              key="select"
              value={coc}
              onChange={setCoc}
              placeholder="Choose a COC"
            >
              {cocs.map((c, i) => {
                return (
                  <Option key={i} value={c.id_coc}>
                    COC {c.order_coc} #({c.id_coc})
                  </Option>
                );
              })}
            </Select>,
            <Button
              key="projectbutton"
            ><Link
                to={"/dashboard/docs/qr-poster/" + props.currentProject}>
              <FontAwesomeIcon icon="qrcode" className="fa-fw" />
                &nbsp; QR Poster
              </Link>
            </Button>,
            <Button
              key="clearancebutton"
            ><Link
                to={"/dashboard/docs/clearance-report/" + props.currentProject}>
              <FontAwesomeIcon icon="clipboard-check" className="fa-fw" />
                &nbsp; Clearance Report
              </Link>
            </Button>,
            <Button key="refreshbutton" onClick={refreshPanel}>
              <FontAwesomeIcon icon="sync" className="fa-fw" />
              &nbsp; Refresh
            </Button>,
          ]}
        />
        <Steps
          style={{ marginBottom: "16px" }}
          type="navigation"
          size="small"
          current={currentStep}
          onChange={setCurrentStep}
        >
          {steps.map((s, i) => {
            return (
              <Step
                key={i}
                status={s.status}
                title={s.title}
                disabled={s.status === "wait"}
              />
            );
          })}
        </Steps>
        <PageHeader title={propz.title} style={{ padding: "0px 0px 16px 0px" }}>
          <ProjectWarnings />
        </PageHeader>
        {propz.children}
      </DependenciesComponent>
    );
  };

  const getProject = async (id_project) => {
    console.log("getting getProject")
    try {
      const response = await axios.current.get("projects/" + id_project);
      return response.data[0];
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const getCocs = async (id_project) => {
    console.log("getting getCocs")
    try {
      const response = await axios.current.get("coc", {
        params: {
          "filter[id_project]": id_project,
        },
      });
      return response.data.rows;
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  const refreshPanel = () => {
    var r = Math.random();
    setNonce(r);
  };

  useEffect(() => {
    if (coc === null) return;
    var len = cocs.length;
    for (var c = 0; c < len; c++) {
      if (cocs[c].id_coc === coc) {
        setCurrentCOC(cocs[c]);
        break;
      }
    }
  }, [coc, cocs]);

  useEffect(() => {
    setCurrentStep(0);
    var projectId = props.currentProject
    if (isNaN(projectId) === true) return;
    console.log("1")
    if (props.projectMode === false) return;
    console.log("2")
    var s = JSON.parse(JSON.stringify(steps));
    console.log(s)
    console.log(s)
    Promise.all([
      getProject(projectId),
      getCocs(projectId),
    ]).then((v) => {
      console.log("got projects")
      console.log("got cocs")
      const p = v[0];
      const c = v[1];
      if (undefined === p || p === null) return;
      if (undefined === c || c === null) return;
      var coc = null;
      setProject(p);
      setCocs(c);
      if (c.length > 0) {
        setCoc(c[0].id_coc);
        coc = c[0];
      }
      s[0].status =
        p.id_author === null || p.id_inspector === null ? "process" : "finish";
      s[1].status =
        s[0].status === "finish"
          ? p.inspection_date_project === null
            ? "process"
            : "finish"
          : "wait";
      s[2].status =
        s[1].status === "finish"
          ? !coc || coc.results_date_coc === null
            ? "process"
            : "finish"
          : "wait";
      s[3].status = s[2].status === "finish" ? "finish" : "wait";
      setSteps(s);
    });
  }, [props.currentProject,props.projectMode]);

  if (props.project === null) return <></>;
  switch (currentStep) {
    case 0:
      return (
        <StepsHeader title="Project">
          <ViewFormComponent
            home="/dashboard/"
            endpoint={props.endpoints.projects.view}
            id={props.currentProject}
            history={props.history}
            update={true}
            remove={false}
            back={false}
          />
        </StepsHeader>
      );
    case 1:
      return (
        <StepsHeader title="Photos and Events">
          <Collapse defaultActiveKey={"photo-event"} accordion>
            <Panel header="Status" key="photo-event">
              <ViewFormComponent
                home="/dashboard/"
                endpoint={props.endpoints.inspections.view}
                id={props.currentProject}
                currentproject={props.currentProject}
                history={props.history}
                update={true}
                back={false}
                remove={false}
              />
              <ListFormComponent
                home="/dashboard/"
                endpoint={props.endpoints.events.list}
                endpoints={props.endpoints}
                currentproject={props.currentProject}
                history={props.history}
                create={false}
                filter={{
                  id_project: props.currentProject,
                }}
                back={false}
              />
              <ListFormComponent
                home="/dashboard/"
                endpoints={props.endpoints}
                endpoint={props.endpoints.samples.list}
                history={props.history}
                currentproject={props.currentProject}
                create={false}
                filter={{
                  id_coc: coc,
                }}
                back={false}
              />
              <ListFormComponent
                home="/dashboard/"
                endpoints={props.endpoints}
                endpoint={props.endpoints.photos.list}
                history={props.history}
                currentproject={props.currentProject}
                create={false}
                filter={{
                  id_project: props.currentProject,
                }}
                back={false}
              />
            </Panel>
            <Panel header="Add Photo" key="2">
              <EditFormComponent
                home="/dashboard/"
                endpoints={props.endpoints}
                endpoint={props.endpoints.photos.create}
                currentproject={props.currentProject}
                values={{ id_project: props.currentProject }}
                disabled={["id_project"]}
                history={props.history}
                back={false}
              />
            </Panel>
            <Panel header="Add Event" key="3">
              <EditFormComponent
                home="/dashboard/"
                endpoints={props.endpoints}
                currentproject={props.currentProject}
                endpoint={props.endpoints.events.create}
                values={{
                  id_project: props.currentProject,
                  id_coc: coc,
                }}
                disabled={["id_project", "id_coc"]}
                currentProject={props.currentProject}
                history={props.history}
                back={false}
              />
            </Panel>
          </Collapse>
        </StepsHeader>
      );
    case 2:
      return (
        <StepsHeader title="COCs and Samples">
          {cocs.length === 0 && (
            <EditFormComponent
              home="/dashboard/"
              endpoints={props.endpoints}
              endpoint={props.endpoints.coc.create}
              history={props.history}
              values={{ id_project: props.currentProject }}
              disabled={["id_project"]}
              back={false}
            />
          )}
          {coc && cocs && (
            <>
              <Collapse defaultActiveKey={"hola"} accordion>
                <Panel header="Status" key="hola">
                  <CocPage id_coc={coc} endpoints={props.endpoints} />
                  <ViewFormComponent
                    home="/dashboard/"
                    endpoint={props.endpoints.coc.view}
                    history={props.history}
                    remove={false}
                    id={coc}
                    update={true}
                    back={false}
                  />
                  <ListFormComponent
                    home="/dashboard/"
                    endpoint={props.endpoints.samples.list}
                    endpoints={props.endpoints}
                    history={props.history}
                    create={false}
                    filter={{
                      id_coc: coc,
                    }}
                    back={false}
                  />
                </Panel>
              </Collapse>
            </>
          )}
        </StepsHeader>
      );
    case 3:
      return (
        <StepsHeader title="Report">
          <ListFormComponent
            home="/dashboard/"
            endpoint={props.endpoints["report-view"].list}
            endpoints={props.endpoints}
            history={props.history}
            create={false}
            filter={{
              id_project: props.currentProject,
            }}
            back={false}
          />
          <ListFormComponent
            home="/dashboard/"
            endpoint={props.endpoints["recommendations-view"].list}
            endpoints={props.endpoints}
            history={props.history}
            create={false}
            filter={{
              id_project: props.currentProject,
            }}
            back={false}
          />
          <InputTableComponent
            endpoint={props.endpoints["removed-risks"].update}
            endpoints={props.endpoints}
            currentProject={props.currentProject}
            title={"Removed Risks"}
          />
          <ReportEditorPage
            id={props.currentProject}
            endpoints={props.endpoints}
          />
          <EditFormComponent
            home="/dashboard/"
            endpoints={props.endpoints}
            endpoint={props.endpoints["report-approval"].update}
            id={props.currentProject}
            currentProject={props.currentProject}
            history={props.history}
            back={false}
          />
        </StepsHeader>
      );
    default:
      return <StepsHeader title="Not Found"></StepsHeader>;
  }
}

export default ProjectPage;
